import { render, staticRenderFns } from "./route-button-card.vue?vue&type=template&id=bd7f7b68&"
import script from "./route-button-card.vue?vue&type=script&lang=ts&"
export * from "./route-button-card.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports